import React from "react";
import { useNavigate } from "react-router-dom";

const ApplicationError: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8f9fa",
        color: "#333",
        fontFamily: "sans-serif",
      }}
    >
      <svg
        width="80"
        height="80"
        viewBox="0 0 24 24"
        fill="none"
        style={{ marginBottom: 24 }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" stroke="#f39c12" strokeWidth="2" />
        <path
          d="M12 8v4"
          stroke="#f39c12"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="12" cy="16" r="1.5" fill="#f39c12" />
      </svg>
      <h1 style={{ fontSize: "2rem", marginBottom: 12 }}>Application Error</h1>
      <p style={{ fontSize: "1.1rem", maxWidth: 600, textAlign: "center" }}>
        We’re having trouble connecting to the server.
        <br />
        Please check your internet connection or try again later.
      </p>
    </div>
  );
};

export default ApplicationError;
